/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { WidgetGuard } from 'features/types'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  UnexpectedServiceErrorGuard
} from '../../../share/guards'
import SourceDonutEmptyResultGuard from './SourceDonutEmptyResultGuard'

const SourceDonutWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <UnexpectedServiceErrorGuard widgetId={widgetId}>
      <TopicIndexNotReadyGuard widgetId={widgetId}>
        <SourceDonutEmptyResultGuard widgetId={widgetId}>{children}</SourceDonutEmptyResultGuard>
      </TopicIndexNotReadyGuard>
    </UnexpectedServiceErrorGuard>
  </TopicInaccessibleGuard>
)

export default SourceDonutWidgetDataGuards
